import { isNilOrEmpty } from 'ramda-adjunct'

const getJsonStoredValue = key => {
  const item = localStorage.getItem(key)

  if (isNilOrEmpty(item)) {
    return null
  }

  try {
    return JSON.parse(item)
  } catch (error) {
    localStorage.removeItem(key)

    return null
  }
}

export default getJsonStoredValue
